import {createBaseShape} from './createBaseShape'

export const createCircle = (attrs) => {
  let strokeSize = 2
  let strokeColor = 'black'
  let fillColor
  let dash
  let lineCap

  if (typeof window.strokeSize !== 'undefined') {
    strokeSize = window.strokeSize
  }

  if (typeof window.strokeColor !== 'undefined') {
    strokeColor = window.strokeColor
  }

  if (typeof window.lineType !== 'undefined') {
    dash = window.lineType[0]
    lineCap = window.lineType[1]
  }

  if (typeof window.fillColor !== 'undefined') {
    fillColor = window.fillColor
  }

  return Object.assign(createBaseShape(attrs), {
    radius: 50,
    stroke: strokeColor,
    strokeWidth: strokeSize,
    dash: dash,
    fill: fillColor,
    lineCap: lineCap
  })
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/createCircle.js